/* This is generated code, don't alter */
var IfcMedicalDeviceTypeEnum;
(function (IfcMedicalDeviceTypeEnum) {
    IfcMedicalDeviceTypeEnum[IfcMedicalDeviceTypeEnum["AIRSTATION"] = 0] = "AIRSTATION";
    IfcMedicalDeviceTypeEnum[IfcMedicalDeviceTypeEnum["FEEDAIRUNIT"] = 1] = "FEEDAIRUNIT";
    IfcMedicalDeviceTypeEnum[IfcMedicalDeviceTypeEnum["OXYGENGENERATOR"] = 2] = "OXYGENGENERATOR";
    IfcMedicalDeviceTypeEnum[IfcMedicalDeviceTypeEnum["OXYGENPLANT"] = 3] = "OXYGENPLANT";
    IfcMedicalDeviceTypeEnum[IfcMedicalDeviceTypeEnum["VACUUMSTATION"] = 4] = "VACUUMSTATION";
    IfcMedicalDeviceTypeEnum[IfcMedicalDeviceTypeEnum["USERDEFINED"] = 5] = "USERDEFINED";
    IfcMedicalDeviceTypeEnum[IfcMedicalDeviceTypeEnum["NOTDEFINED"] = 6] = "NOTDEFINED";
})(IfcMedicalDeviceTypeEnum || (IfcMedicalDeviceTypeEnum = {}));
const IfcMedicalDeviceTypeEnumCount = 7;
export { IfcMedicalDeviceTypeEnum, IfcMedicalDeviceTypeEnumCount };
/* This is generated code, don't alter */
import MinimalPerfectHash from "../../indexing/minimal_perfect_hash.js";
let gMapIfcMedicalDeviceTypeEnum = new Int32Array([292]);
let prefixSumAddressIfcMedicalDeviceTypeEnum = new Uint32Array([0, 13, 25, 42, 54, 67, 80, 95]);
let slotMapIfcMedicalDeviceTypeEnum = new Int32Array([1, 6, 2, 0, 5, 3, 4]);
let encodedDataIfcMedicalDeviceTypeEnum = (new TextEncoder()).encode(".FEEDAIRUNIT..NOTDEFINED..OXYGENGENERATOR..AIRSTATION..USERDEFINED..OXYGENPLANT..VACUUMSTATION.");
let IfcMedicalDeviceTypeEnumSearch = new MinimalPerfectHash(gMapIfcMedicalDeviceTypeEnum, prefixSumAddressIfcMedicalDeviceTypeEnum, slotMapIfcMedicalDeviceTypeEnum, encodedDataIfcMedicalDeviceTypeEnum);
export { IfcMedicalDeviceTypeEnumSearch };
/* This is generated cold, don't alter */
import StepEnumParser from "../../step/parsing/step_enum_parser.js";
const parser = StepEnumParser.Instance;
export function IfcMedicalDeviceTypeEnumDeserializeStep(input, cursor, endCursor) {
    return parser.extract(IfcMedicalDeviceTypeEnumSearch, input, cursor, endCursor);
}
